import {ThemedStyleSheet} from '../../Utils/ThemedStyleSheet';
import {Spacing} from '../../Styles';

export default ThemedStyleSheet((theme) => ({
  container: {
    flex: 1,
  },
  scrollContent: {
    flexGrow: 1,
    paddingTop: Spacing.small,
    paddingBottom: Spacing.medium,
  },
  topBar: {
    width: '100%',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    minHeight: 44,
    zIndex: 20,
  },
  brandLockup: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  appLogo: {
    width: 58,
    height: 58,
    marginRight: Spacing.small,
  },
  quickControls: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  controlChip: {
    minWidth: 38,
    minHeight: 34,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: theme.colors.border,
    backgroundColor: theme.colors.surface,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: Spacing.xsmall,
    marginLeft: Spacing.xxsmall,
  },
  languageControl: {
    minWidth: 44,
  },
  languageMenuContainer: {
    position: 'relative',
    zIndex: 30,
  },
  languageMenu: {
    position: 'absolute',
    top: 40,
    left: 4,
    width: 184,
    paddingVertical: Spacing.xxsmall,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: theme.colors.border,
    backgroundColor: theme.colors.surface,
    shadowColor: theme.colors.textStrong,
    shadowOffset: {width: 0, height: 4},
    shadowOpacity: 0.16,
    shadowRadius: 10,
    elevation: 6,
    zIndex: 40,
  },
  languageMenuItemTouchable: {
    width: '100%',
  },
  languageMenuItem: {
    minHeight: 44,
    justifyContent: 'center',
    paddingHorizontal: Spacing.small,
    paddingVertical: Spacing.xsmall,
  },
  languageMenuItemSelected: {
    backgroundColor: theme.colors.surfaceSecondary,
  },
  menuText: {
    color: theme.colors.textStrong,
    lineHeight: 20,
  },
  controlChipActive: {
    borderColor: theme.colors.primary,
    backgroundColor: theme.colors.secondary,
  },
  controlChipText: {
    color: theme.colors.primary,
    fontSize: 12,
    lineHeight: 16,
  },
  infoControl: {
    width: 38,
    height: 34,
    borderRadius: 8,
    margin: 0,
    marginLeft: Spacing.xxsmall,
  },
  resumePromptCard: {
    marginTop: Spacing.small,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: theme.colors.border,
    backgroundColor: theme.colors.surface,
    padding: Spacing.small,
  },
  resumePromptTitle: {
    color: theme.colors.textStrong,
  },
  resumePromptBody: {
    marginTop: Spacing.xxsmall,
    color: theme.colors.textLight,
    lineHeight: 20,
  },
  resumePromptActions: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'flex-end',
    marginTop: Spacing.xsmall,
  },
  resumePromptButton: {
    marginLeft: Spacing.xxsmall,
    marginTop: Spacing.xxsmall,
  },
  mainContent: {
    flexGrow: 1,
    justifyContent: 'center',
    paddingTop: Spacing.small,
    paddingBottom: Spacing.small,
  },
  heroPanel: {
    alignItems: 'flex-start',
    marginBottom: Spacing.medium,
    backgroundColor: theme.colors.surface,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: theme.colors.border,
    padding: Spacing.small,
  },
  title: {
    color: theme.colors.textStrong,
    fontSize: 40,
    lineHeight: 46,
    fontWeight: '800',
    flexShrink: 1,
  },
  subtitle: {
    marginTop: Spacing.small,
    color: theme.colors.textLight,
    lineHeight: 24,
    maxWidth: 380,
    textAlign: 'left',
  },
  credibilityCue: {
    alignSelf: 'flex-start',
    marginTop: Spacing.small,
    borderRadius: 8,
    backgroundColor: theme.colors.surfaceSecondary,
    paddingHorizontal: Spacing.small,
    paddingVertical: Spacing.xxsmall,
  },
  credibilityCueText: {
    color: theme.colors.textStrong,
    fontSize: 12,
    lineHeight: 17,
  },
  actionsGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginTop: Spacing.xsmall,
  },
  actionButton: {
    width: '48%',
    borderRadius: 8,
    marginBottom: Spacing.small,
  },
  actionButtonLeft: {
    marginRight: '4%',
  },
  buttonContent: {
    minHeight: 64,
  },
}));
